module.exports = __webpack_public_path__ + "img/bs_qrcode.965719d5.png";